import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import { FeatureFlag } from '@models';

@NgModule()
export class WebhookMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: WebhookMetaModule,
            providers: [
                providePageMeta({
                    title: 'Webhooks',
                    translationKey: 'page_webhooks',
                    routerLink: '/webhooks',
                    svgIcon: 'uipath:webhooks',
                    permission: 'Webhooks.View',
                    type: 'Admin',
                    featureFlag: FeatureFlag.Webhooks,
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 2,
                }),
                providePageMeta({
                    title: 'Add',
                    translationKey: 'page_webhooks_add',
                    routerLink: '/webhooks/add',
                    permission: 'Webhooks.Create',
                    type: 'Breadcrumb',
                    parentRoute: '/webhooks',
                    featureFlag: FeatureFlag.Webhooks,
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'Edit',
                    translationKey: 'page_webhooks_edit',
                    routerLink: '/webhooks/edit/:id',
                    permission: 'Webhooks.Edit',
                    type: 'Breadcrumb',
                    parentRoute: '/webhooks',
                    featureFlag: FeatureFlag.Webhooks,
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
